import { dialog } from "../../../../../nq-component";
import DialogModal from "../../../../../components/Dialog";

function CollapseView({ dp, onEdit, onView }) {
  const DataCard = ({ icon, label, value, accent = "#83c14a" }) => (
    <div
      style={{
        background: "#fff",
        border: "1px solid #E5E7EB",
        borderRadius: "10px",
        padding: "16px",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "4px",
          height: "100%",
          background: accent,
        }}
      ></div>
      <div className="d-flex align-items-start gap-3">
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "10px",
            background: `${accent}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <i
            className={icon}
            style={{ fontSize: "1.125rem", color: accent }}
          ></i>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: "0.75rem",
              color: "#6B7280",
              fontWeight: "600",
              marginBottom: "4px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            {label}
          </div>
          <div
            style={{
              fontSize: "1rem",
              color: "#111827",
              fontWeight: "700",
              wordBreak: "break-word",
            }}
          >
            {value || "—"}
          </div>
        </div>
      </div>
    </div>
  );

  const formattedDate = dp?.created
    ? new Date(dp.created).toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
    : "—";

  const handleAdjustClick = () => {
    const createdDate = new Date(dp?.created).toISOString().slice(0, 10);
    const today = new Date().toISOString().slice(0, 10);

    if (createdDate !== today) {
      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-exclamation-triangle-fill"
            iconColor="#dc3545"
            title="Cannot Proceed"
            message="Cannot proceed with the adjustment because the data you are trying to adjust was not created today."
            isCancelButton={false}
            onSubmit={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } else {
      onEdit();
    }
  };

  return (
    <div
      style={{
        background: "#F9FAFB",
        border: "1px solid #E5E7EB",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "20px",
          paddingBottom: "16px",
          borderBottom: "2px solid #E5E7EB",
        }}
      >
        <i
          className="bi bi-cart-check-fill"
          style={{ fontSize: "1.25rem", color: "#83c14a" }}
        ></i>
        <h6
          style={{
            margin: 0,
            fontSize: "1rem",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Direct Purchase Details
        </h6>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <DataCard
            icon="bi bi-calendar-plus"
            label="Date Created"
            value={formattedDate}
            accent="#83c14a"
          />
        </div>

        <div className="col-md-6">
          <DataCard
            icon="bi bi-box-seam-fill"
            label="Item Name"
            value={dp?.itemName}
            accent="#3B82F6"
          />
        </div>

        <div className="col-md-4">
          <DataCard
            icon="bi bi-upc-scan"
            label="SKU"
            value={dp?.sku}
            accent="#8B5CF6"
          />
        </div>

        <div className="col-md-4">
          <DataCard
            icon="bi bi-123"
            label="Pieces / Quantity"
            value={dp?.quantity}
            accent="#F59E0B"
          />
        </div>

        <div className="col-md-4">
          <DataCard
            icon="bi bi-rulers"
            label="UOM"
            value={dp?.uom?.name}
            accent="#06B6D4"
          />
        </div>

        <div className="col-md-12">
          <DataCard
            icon="bi bi-currency-dollar"
            label="Price"
            value={dp?.price}
            accent="#10B981"
          />
        </div>
      </div>

      <div className="d-flex gap-3">
        <button
          className="btn text-white"
          onClick={handleAdjustClick}
          style={{
            background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)",
            border: "none",
            padding: "10px 20px",
            fontWeight: "600",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(131, 193, 74, 0.3)",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 4px 12px rgba(131, 193, 74, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 2px 8px rgba(131, 193, 74, 0.3)";
          }}
        >
          <i className="bi bi-sliders me-2"></i> Adjust
        </button>
        {/* <button 
          className="btn" 
          onClick={onView}
          style={{
            background: "#F3F4F6",
            color: "#374151",
            padding: "10px 20px",
            fontWeight: "600",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#E5E7EB";
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#F3F4F6";
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.05)";
          }}
        >
          <i className="bi bi-eye-fill me-2"></i> View
        </button> */}
      </div>
    </div>
  );
}

export default CollapseView;
